<div class="row">
  <div class="col-md-12 nopad">
    <div class="card shadow-lg rounded-lg border-0">

      <!-- Header -->
      <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
        <h3 class="mb-0">📊 Stock Report</h3>
      </div>

      <!-- Store Dropdown & Buttons -->
      <div class="card-body filter-section">
        <div class="row g-3">

          <div class="col-sm-6 col-md-4">
            <label>Store Name</label>
            <select class="form-select form-select-sm" [(ngModel)]="selectedStore">
              <option value="" disabled>Select Store</option>
              <option *ngFor="let store of stores" [value]="store.id">{{ store.name }}</option>
            </select>
          </div>

          <div class="col-sm-6 col-md-2 d-flex align-items-end">
            <button (click)="display()" class="btn btn-success w-100" [disabled]="!selectedStore">
              <i class="fas fa-eye me-1"></i> Show
            </button>
          </div>

          <div class="col-sm-6 col-md-2 d-flex align-items-end">
            <button (click)="export_excel()" class="btn btn-info w-100" [disabled]="!StockReport_Row?.length">
              <i class="fas fa-file-excel me-1"></i> Excel
            </button>
          </div>

        </div>
      </div>

      <!-- Stock Table -->
      <div class="card-body">
        <div class="table-responsive" *ngIf="StockReport_Row?.length; else noData">
          <table class="table table-hover table-striped align-middle">
            <thead class="table-primary">
              <tr>
                <th>#</th>
                <th>Product Name</th>
                
                <th>Quantity</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of StockReport_Row; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ row['Item Name'] || row.ItemName || row.POD_Item_Name }}</td>
               
                <td>{{ row['Qty'] || row.Qty }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <ng-template #noData>
          <div class="text-center text-muted my-3">
            No data available. Please select a store.
          </div>
        </ng-template>
      </div>

    </div>
  </div>
</div>
